
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill",attrs:{"fill-rule":"evenodd","d":"M7.969 7.286a.461.461 0 00-.134-.308L1.594.737a.461.461 0 00-.308-.134.461.461 0 00-.308.134l-.67.67a.46.46 0 00-.134.307c0 .107.054.228.134.308l5.263 5.264-5.263 5.263a.463.463 0 00-.134.308c0 .12.054.228.134.308l.67.67c.08.08.2.134.308.134a.461.461 0 00.308-.134l6.24-6.241a.46.46 0 00.135-.308z"}})])
          )
        }
      }
    